import { Button } from '@finn-auto/design-system/atoms/button';
import { X } from 'lucide-react';
import { PersonPicker } from './PersonPicker';

/**
 * The TA manager who owns this role's process.
 *
 * A free-text email box here was a trap: it is the axis the overview filters on,
 * so one typo drops a link out of its owner's view entirely, and nothing says so.
 * Same directory search as the interviewer box, so the address can only ever be
 * one that exists.
 */
export function TaOwnerPicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (email: string) => void;
}) {
  const current = value.trim();

  return (
    <label className="block">
      <span className="mb-1 block text-xs font-medium text-gray-700">TA manager (owner)</span>

      {current ? (
        <div className="flex items-center gap-2 rounded-xl border border-gray-300 px-3 py-2">
          <span className="truncate text-sm text-gray-900">{current}</span>
          <Button
            size="sm"
            variant="ghost"
            type="button"
            className="ml-auto shrink-0"
            onClick={() => onChange('')}
            title="Clear, to pick someone else"
          >
            <X className="h-3.5 w-3.5" />
          </Button>
        </div>
      ) : (
        <PersonPicker
          onSelect={(person) => onChange(person.email)}
          placeholder="Start typing a name — e.g. Sofia"
          // Directory matches only. A typed address would reintroduce exactly the
          // failure this field replaced: the overview filters on this value, so a
          // misspelling hides the link from the person who owns it, silently.
          allowTypedEmail={false}
        />
      )}

      <span className="mt-1 block text-xs text-gray-500">
        Used to filter the list by who owns the role.
      </span>
    </label>
  );
}
